/* eslint-disable @typescript-eslint/no-explicit-any */
import { hasFeature } from "../Actions/UserActions";
import { CompanyType } from "../Enums/CompanyType";
import { OktaGroups } from "../Enums/Enums";
import { ScoutFeature } from "../Enums/ScoutFeature";
import { ICompany, IUser } from "../Models/Models";

declare const scout;

export const performanceUnit = (company: ICompany): "Visits" | "Sales" => {
    /*
    GROCER = 1,
    RETAILER = 2,
    RESTAURANT = 3,
    OTHER = 4,
    POSTAL = 5,
    BUSINESS_SERVICE = 6,
    CONVIENCE_STORE = 7,
    COMMUNITY = 8,
    HEALTHCARE = 9,
    HOSPITALITY = 100,
    NOT_SPECIFIED = 255
    */

    switch (company.companyType) {
        case 9:
            return "Visits";
        default:
            return "Sales";
    }
};

export const intercomCallbacks = (user: IUser): void => {
    if (hasFeature(user, ScoutFeature.Intercom)) {
        (window as any).intercomSettings = {
            app_id: $("#IntercomAppID").text(),
            custom_launcher_selector: ".buxton-intercom",
        };

        (window as any).Intercom("onShow", () => {
            $(".buxton-intercom-content-close").show();
            $(".buxton-intercom-content-open").hide();
        });
        (window as any).Intercom("onHide", () => {
            $(".buxton-intercom-content-close").hide();
            $(".buxton-intercom-content-open").show();
        });

        (window as any).Intercom("onUnreadCountChange", (unreadCount) => {
            if (unreadCount > 0) {
                $("#intercom-counter").show();
                $("#intercom-counter").text(unreadCount);
            } else {
                $("#intercom-counter").hide();
            }
        });
    }
};

const intercomUserPermission = (user: IUser) => {
    let userPermission = "";
    if (user.isFranchisee) {
        userPermission = "Franchisee";
    } else if (user.isAdmin) {
        userPermission = "Administrator";
    } else if (!user.isAdmin && !user.isFranchisee) {
        userPermission = "Standard";
    }
    return userPermission;
};

const intercomCompanyType = (companyType: CompanyType) => {
    let companyTypeString = "";
    switch (companyType) {
        case CompanyType.RETAILER:
            companyTypeString = "Retail";
            break;
        case CompanyType.HEALTHCARE:
            companyTypeString = "Health Care";
            break;
        case CompanyType.COMMUNITY:
            companyTypeString = "Community";
            break;
        case CompanyType.HOTEL:
            companyTypeString = "Hotel";
            break;
        case CompanyType.MARRIOTT:
            companyTypeString = "Marriott";
            break;
    }
    return companyTypeString;
};

export const intercomBoot = (user: IUser): void => {
    if (hasFeature(user, ScoutFeature.Intercom)) {
        (window as any).Intercom("boot", {
            app_id: $("#IntercomAppID").text(),
            name: user.fullName,
            email: user.email,
            user_id:
        scout.user.current.oktaGroups.indexOf(OktaGroups.BUXTONCORP) > -1
            ? user.oktaUserID
            : user.userID,
            CID: user.company.cid,
            persona_id: user.personaID,
            PermissionLevel: intercomUserPermission(user),
            company: {
                id: user.company.cid,
                name: user.company.name,
                CompanyType: intercomCompanyType(user.company.companyType),
                Expiration: user.company.expireDateTimeFriendly,
                MaxActiveUserCount: user.company.maxActiveUserCount,
            },
        });
    }
};